import { useQuery } from '@tanstack/react-query'
import { useCustomerId } from 'features/customers/hooks/useCustomerId'

import type { EChangeSource } from '@albacross/types'

import { get } from 'utils/http'

export type FeatureChangeActor = {
  id: number
  first_name: string | null
  last_name: string | null
  email: string | null
}

export type FeatureChange = {
  id: number
  feature_key: string
  old_value: unknown
  new_value: unknown
  source: EChangeSource
  set_by_user_id: number | null
  note: string | null
  changed_at: string
  setBy: FeatureChangeActor | null
}

export type FeatureChangeLog = {
  changes: FeatureChange[]
  overridden: string[]
}

export const useCustomerFeatureChanges = (specificCustomerId?: number) => {
  const urlParamsCustomerId = useCustomerId()
  const customerId = specificCustomerId || urlParamsCustomerId

  return useQuery<FeatureChangeLog>({
    queryKey: ['customer', customerId, 'feature_changes'],
    queryFn: () => get(`/management/customers/${customerId}/feature_changes`),
  })
}
